module.exports = __webpack_public_path__ + "img/23.dfd11865.jpg";